/**
 * The live-demo booking calendar — one address for the pages that open it in a dialog: the new design's shell
 * (src/design/pavilion/shell/shellContent.ts re-exports it) and today's page for firms (src/pages/ForEnterprise.tsx),
 * whose rebuild opens the shell's booking dialog (PV4, design record §7b). It lives outside the shell because a page
 * on the first download that imported the shell's modules would carry them into main.js.
 *
 * Other copies of the address remain (GlobalFooter, LandingPage, Pricing, Mission): each is its own page's link, and
 * LandingPage's is pinned against the home page's rebuild (tests/landing/pavilionHomeParity.test.tsx).
 */
export const BOOKING_CALENDAR_SRC =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2bVpuAMuVJh3Xikmu1Bi9AuBaaHxB5a-HeOlE8xm3l2ehjgrdvG5QQEqmrLDKsF1Vgbncg2BIK?gv=true';
